export const Weblabs = Object.freeze({
    gapsVendorCentralDefaultMode: 'GAPS_VC_DEFAULT_MODE_1304128',
});
